import { render, staticRenderFns } from "./BsModal.vue?vue&type=template&id=4b5e165e&scoped=true"
import script from "./BsModal.vue?vue&type=script&lang=js"
export * from "./BsModal.vue?vue&type=script&lang=js"
import style0 from "./BsModal.vue?vue&type=style&index=0&id=4b5e165e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e165e",
  null
  
)

export default component.exports